import useGoBack from 'hooks/useGoBack';
import useIsModal from 'hooks/useIsModal';
import useSearchParams from 'hooks/useSearchParams';
import React from 'react';
import { useLocation } from 'react-router-dom';
import useLocalizedNavigate from '~/hooks/useLocalizedNavigate';
import Modal from '~/reusable-components/dialogs/Modal';
import ModalHeader from '~/reusable-components/dialogs/Modal/ModalHeader';
import Section from '~/reusable-components/layout/Section';

const CSS = require('./ModalPage.module.scss');

interface ModalPageProps {
  title: React.ReactNode;
  isWide?: boolean;
  children: React.ReactNode;
  hideBackButton?: boolean;
}

function ModalPage({
  children,
  title,
  isWide,
  hideBackButton,
}: ModalPageProps) {
  const isModal = useIsModal();
  const goBack = useGoBack();
  const navigate = useLocalizedNavigate();
  const location = useLocation();
  const searchParams = useSearchParams();

  if (isModal) {
    return (
      <Modal title={title} onClose={goBack} fullscreen="mobile" isWide={isWide}>
        {children}
      </Modal>
    );
  }

  const returnTo = searchParams.get('returnTo') || '/';
  const onBack = () =>
    location.state?.modal ? goBack() : navigate(returnTo, { replace: true });

  return (
    <>
      <Section
        as="header"
        isNarrow={!isWide}
        noSpace="all"
        variant="sandstone"
        noPadding
      >
        <ModalHeader
          title={title}
          onBack={hideBackButton ? undefined : onBack}
          isPageHeader
        />
      </Section>
      <Section isNarrow={!isWide} noSpace="all">
        <div className={CSS.PageContent}>{children}</div>
      </Section>
    </>
  );
}

export default ModalPage;
